
import { Tooltip, OverlayTrigger, Button } from 'react-bootstrap';

const ITooltip = () => {
  const tooltip = (
    <Tooltip id="tooltip" style={{ fontSize: "11px", backgroundColor: "#FFF"}}>
         You can Apply more than 5000 points.
    </Tooltip>
  );
  return (
    <div>
      <OverlayTrigger placement="top" overlay={tooltip}>
        <Button style={{ padding: "0", background: "transparent", border: "none", color: "rgb(93 90 90)", fontSize: "12px" }}><i className="bi bi-info-circle-fill"></i></Button>
      </OverlayTrigger>
    </div>
  );
};
export default ITooltip;
